import React from 'react';
import useCompany from 'gatsby-theme-core/src/hooks/use-company';
import { useVehicle } from '../vehicle-context';

const Success = ({ lead }) => {
  const company = useCompany();
  const { company: rawVehicleCompany } = useVehicle();
  const vehicleCompany = useCompany({
    documentId: rawVehicleCompany?.documentId, // apollo v5
    strapiId: rawVehicleCompany?.strapiId, // apollo v4
    id: rawVehicleCompany?.id, // gatsby
  });
  const contact = vehicleCompany?.mainContact || vehicleCompany || company;
  const {
    name,
    tel,
    email,
    dateOfBirth,
    vehicleTradein,
    fields,
  } = lead;
  return (
    <section>
      <h1>Bedankt voor uw aanvraag</h1>
      <p>Wij hebben de volgende gegevens ontvangen</p>
      <table className="no-styling">
        <tbody>
          {name && (
            <tr>
              <td>Naam:</td>
              <td>{name}</td>
            </tr>
          )}
          {tel && (
            <tr>
              <td>Telefoonnummer:</td>
              <td>{tel}</td>
            </tr>
          )}
          {email && (
            <tr>
              <td>E-mailadres:</td>
              <td>{email}</td>
            </tr>
          )}
          {dateOfBirth && (
            <tr>
              <td>Geboortedatum:</td>
              <td>{dateOfBirth}</td>
            </tr>
          )}
        </tbody>
      </table>
      {Object.keys(vehicleTradein || {}).length > 0 && (
        <table className="no-styling">
          <tbody>
            <tr>
              <td>Inruilauto:</td>
              <td>Ja</td>
            </tr>

            {vehicleTradein.licensePlate && (
              <tr>
                <td>Kenteken:</td>
                <td>{vehicleTradein.licensePlate}</td>
              </tr>
            )}
            {vehicleTradein.odometer && (
              <tr>
                <td>Kilometerstand:</td>
                <td>{vehicleTradein.odometer}</td>
              </tr>
            )}
            {vehicleTradein.color && (
              <tr>
                <td>Kleur:</td>
                <td>{vehicleTradein.color}</td>
              </tr>
            )}
            {vehicleTradein.comments && (
              <tr>
                <td>Opmerkingen:</td>
                <td>{vehicleTradein.comments}</td>
              </tr>
            )}

            {(vehicleTradein.fields || {}).length > 0
              && Object.entries(vehicleTradein.fields).map(([field, val]) => (
                <tr key={field}>
                  <td>{field}:</td>
                  <td>{val}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
      {fields && (
        <table className="no-styling">
          <tbody>
            {Object.entries(fields).map(([key, value]) => (
              <tr key={key}>
                <td>{key}:</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <p>
        Wij zullen zo snel mogelijk contact opnemen via uw aangegeven contactmogelijkheden.
      </p>
      {(contact.tel || contact.email) && (
        <p>
          <span>Heeft u vragen of andere opmerkingen </span>
          {contact.tel && <span>bel ons op <a href={`tel:${contact.vehicleSalesTelWithCountryCode || contact.telWithCountryCode}`}>{contact.vehicleSalesTel || contact.tel}</a></span>}
          {contact.tel && company.email && <span> of </span>}
          {contact.email && <span>mail naar <a href={`mailto:${contact.email}`}>{contact.email}</a></span>}
        </p>
      )}
    </section>
  );
};

export default Success;
